var portfolioHeader = {
	baseCurrency: "Basisvaluta",
	numberOfPositions: "Posities",
	portfolioValue: "Portfolio-waarde in {currency}",
	todayChange: "Verschil vandaag",
	unrealizedPerformance: "Ongerealiseerde prestatie.",
	purchaseValue: "Aankoopwaarde",
	realizedProfits: "Gerealiseerde winsten",
	totalValue: "Totale waarde",
	totalPerformance: "Totaal verschil",
	lastCalculationDateTime: "Laatste berekening"
};
var nl = {
	portfolioHeader: portfolioHeader
};

export { nl as default, portfolioHeader };
